// extracted by mini-css-extract-plugin
export default {"positive":"style_positive__xeQlz","neutral":"style_neutral__g3AAJ","negative":"style_negative__qFI77"};